import React from "react";
import { Link } from "react-router-dom";
import "../styles/Research1.css";
import "../styles/Navbar.css";

import headerborder from "../assets/images/bordder-line.svg";
import content from "../assets/images/content.svg";

import researchimage2 from "../assets/images/research-2.svg";
import researchimage4 from "../assets/images/research-4.svg";
import fullreport from "../assets/images/full-report-icon.svg";
import reasearchcardborder from "../assets/images/research-card-border.svg";
import analytics2 from "../assets/images/analytics-research-4.png";
import analytics3 from "../assets/images/analytics-2-research-4.png";
import tangoLogo from "../assets/logos/Tango.png";

const Research1 = () => {
  // Asset paths from src/assets folder


  return (
    <div className="research-page">
      {/* Research Content */}
      <div className="Research1-container">
        <div className="research-heading-container">
          <img src={headerborder} alt="headerborder" className="headerborder" />
          <div className="research-content-wrapper">
            <div className="inner-research">
              <div className="research-header-content">
                <div>
                  <p className="research-heading">
                    USDA McGovern-Dole Grant: Home Grown School{" "}
                  </p>
                  <p className="research-heading">
                    Feeding Program - Phase II Endline & Phase III Baseline
                  </p>
                </div>
                <img src={tangoLogo} alt="Tango Logo" className="tango-logo" />
              </div>
              <p className="date">April - August 2025</p>
              <p className="partnership">
                Partnership: IHEMA Research Team & Tango International
              </p>
              <p className="research-role-detail">
                <span className="role-label">IHEMA's Role:</span>
                <span className="role-badge">Data Collection &amp; Reporting</span>
              </p>
            </div>
          </div>
        </div>
        <div className="content-container">
          <p className="content-paragraph">
            IHEMA Research Team conducted a comprehensive dual-purpose evaluation of Rwanda’s Home Grown School Feeding Program, combining the Phase II endline assessment with the establishment of a baseline for Phase III. The evaluation was designed to ensure methodological comparability across program phases while adapting to evolving program strategies and priorities.
          </p>
          <p className="content-paragraph">
            The study covered 54 schools nationwide and employed a rigorous mixed-methods approach, integrating quantitative school surveys, Early Grade Reading Assessment (EGRA) for Primary 2 learners, and extensive qualitative stakeholder interviews. Digital data collection tools and robust quality assurance protocols ensured high data accuracy and reliability.          </p>
          <p className="content-paragraph">
            The evaluation generated critical evidence on educational outcomes, program implementation quality, sustainability, and community engagement, including linkages with local agricultural systems. Findings informed Phase III program design and contributed to policy discussions on school feeding as both an education and nutrition intervention in Rwanda.          </p>
          <img src={content} alt="content" className="content-image" />
          <div className="analytics">
            <img src={analytics2} alt="Analytics" className="analytics" />
            <img src={analytics3} alt="Analytics" className="analytics" />
          </div>
        </div>
        <div className="research-card-container">
          <img src={reasearchcardborder} alt="headerborder" className="research-card-border" />
          <div className="outer-container">
            <p className="more-assessments">More Assessments</p>
            <div className="cards-container">
              <div className="research-card">
                <div className="research-card-info">
                  <p className="research-card-paragraph">
                    Rapid review of the Mastercard Foundation COVID-19 Recovery
                    and Resilience Program (CRRP Rwanda)
                  </p>
                  <div className="research-role-tag">
                    <span className="role-label">IHEMA's Role:</span>
                    <span className="role-value">Data Collection &amp; Reporting</span>
                  </div>
                </div>
                <img
                  src={researchimage2}
                  alt="research-card"
                  className="research-card-image"
                />
                <Link to="/research/mastercard-foundation" className="read-more-link">
                  <img
                    src={fullreport}
                    alt="full report"
                    className="full-report"
                  />
                </Link>
              </div>
              <div className="research-card">
                <div className="research-card-info">
                  <p className="research-card-paragraph">
                    Impact study of World Vision Rwanda programs focusing on
                    community development and educational initiatives
                  </p>
                  <div className="research-role-tag">
                    <span className="role-label">IHEMA's Role:</span>
                    <span className="role-value">Data Collection &amp; Reporting</span>
                  </div>
                </div>
                <img
                  src="https://res.cloudinary.com/dsxiw1bop/image/upload/v1770284459/research-3_pu8jhx.svg"
                  alt="research-card"
                  className="research-card-image"
                />
                <Link to="/research/world-vision" className="read-more-link">
                  <img
                    src={fullreport}
                    alt="full report"
                    className="full-report"
                  />
                </Link>
              </div>
              <div className="research-card">
                <div className="research-card-info">
                  <p className="research-card-paragraph">
                    USDA McGovern-Dole Grant: Home Grown School Feeding Program -
                    Phase II Midterm Evaluation
                  </p>
                  <div className="research-role-tag">
                    <span className="role-label">IHEMA's Role:</span>
                    <span className="role-value">Data Collection &amp; Reporting</span>
                  </div>
                </div>
                <img
                  src={researchimage4}
                  alt="research-card"
                  className="research-card-image"
                />
                <Link to="/research/mcgovern-dole-midterm" className="read-more-link">
                  <img
                    src={fullreport}
                    alt="full report"
                    className="full-report"
                  />
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Research1;
